import { render, staticRenderFns } from "./SasvEmailTemplate.vue?vue&type=template&id=762c83e6"
import script from "./SasvEmailTemplate.vue?vue&type=script&lang=js"
export * from "./SasvEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./SasvEmailTemplate.vue?vue&type=style&index=0&id=762c83e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports